import React from "react";
import { pick } from "../utils/fieldExtractors";

function truncate(text, max = 80) {
  if (!text) return "";
  return text.length > max ? text.slice(0, max - 1) + "…" : text;
}

export default function TicketSelect({ tickets, value, onChange, disabled }) {
  return (
    <select
      id="ticketSelect"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className="st-select"
    >
      {tickets.length === 0 ? (
        <option value="">No tickets</option>
      ) : (
        tickets.map((t) => {
          const id = pick(t, "Id") ?? pick(t, "id");
          const summary = truncate(pick(t, "Summary") ?? pick(t, "summary") ?? "", 90);
          const projectId = pick(t, "Project.Id") ?? pick(t, "project.id") ?? "";
          const label = `#${id ?? "?"} | ${summary} (Project ID: ${projectId || "?"})`;
          return (
            <option key={String(id)} value={String(id)}>
              {label}
            </option>
          );
        })
      )}
    </select>
  );
}
